module.exports = __webpack_public_path__ + "static/MR_APR19_Elf_600x600px-6e2640fb097b7072948416552a2001bc.jpg";